<template>
  <section class="service-seo-content" :class="[`variant-${variant}`]" data-seo-host="content">
    <h1>{{ service.name }}{{ areaSuffix }}</h1>
    <p class="seo-intro">{{ copy.intro }}</p>
    <article v-for="section in copy.sections" :key="section.heading">
      <h2>{{ section.heading }}</h2>
      <p>{{ section.body }}</p>
    </article>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { buildServiceSeoCopy, serviceArea, type SeoService } from '@/services/seo/serviceSeo';

const areaSuffix = computed(() => (serviceArea() ? ` en ${serviceArea()}` : ''));

const props = withDefaults(
  defineProps<{
    service: SeoService;
    variant?: 'hidden' | 'full';
  }>(),
  { variant: 'hidden' },
);

const copy = computed(() => buildServiceSeoCopy(props.service));
</script>

<style scoped>
.service-seo-content {
  font-family: 'Inter', sans-serif;
}

/* Variante invisible al usuario pero visible para el DOM y Google (patrón sr-only). */
.variant-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Variante completa: página pública /servicios/:slug */
.variant-full {
  max-width: 860px;
  margin: 0 auto;
  padding: 40px 20px 80px;
}

.variant-full h1 {
  font-size: clamp(2.2rem, 6vw, 3.4rem);
  font-weight: 900;
  color: #2d3436;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
}

.variant-full h2 {
  font-size: 1.5rem;
  font-weight: 800;
  color: #8d17c4;
  margin: 36px 0 10px;
}

.variant-full p {
  font-size: 1.08rem;
  line-height: 1.75;
  color: #4b5563;
}

.variant-full .seo-intro {
  font-size: 1.2rem;
  color: #2d3436;
}
</style>
